import store from "@/store";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

export function fetchAnnouncementNumber() {
  store
    .dispatch("data/getAnnouncementNumber")
    .then((res: number) => {
      store.commit("data/setAnnouncementNumber", res);
    })
    .catch(() => {
      console.error(`get announcement number error`);
    });
}

export function unreadAnnouncementNumber(): number {
  const totalAnnouncementNumber = store.state.data.announcementNumber;
  if (totalAnnouncementNumber === undefined) {
    store.commit("data/setreadAnnouncementNumber", 0);
    return 0;
  }
  const readAnnouncementList: PortalAdapterApi.ResponseGetNotice[] = JSON.parse(localStorage.announcementList || "[]");
  store.commit("data/setReadAnnouncementNumber", readAnnouncementList.length);
  return totalAnnouncementNumber - readAnnouncementList.length;
}

export function initAnnouncementList() {
  if (typeof Storage !== "undefined") {
    if (!localStorage.announcementList) {
      localStorage.announcementList = "";
    }
  } else {
    console.error("Your browser is not supported to HTML5 storage");
  }
}
